<template>
  <el-container>
    <el-main>
      <el-table
          :data="commodityData"
          border
          highlight-current-row
          style="width: 100%">
        <el-table-column
            type="index"
            label="序号"
            width="50"
            fixed="left"
        >
        </el-table-column>
        <el-table-column
            prop="createByName"
            fixed
            label="发送者"
        >
        </el-table-column>
        <el-table-column
            prop="comment"
            fixed
            label="评论内容"
        >
        </el-table-column>
        <el-table-column
            prop="reviewStatus"
            :formatter="f_reviewStatus"
            label="是否审核"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间"
            :formatter="dateFormat"
            width="170"
        >
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="300"
        >
          <template slot-scope="scope">
            <el-button :disabled="scope.row.reviewStatus == 2"  type="text" size="small" @click="okreviewStatus(scope.row)">通过</el-button>
            <el-button :disabled="scope.row.reviewStatus == 1" type="text" size="small" @click="noreviewStatus(scope.row)">不通过</el-button>
            <el-button @click="deleteBlogsComment(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat, monthFormat} from '@/api/utils.js';

  const formData = {};
  export default {
    data() {
      return {
        formData: JSON.parse(JSON.stringify(formData)),
        commodityData: [],
        href: '',
        searchData: {
          orgCode: '',
          id:'',
          blogId:''

        },
        categoryData: [],
        commoditys: [],
        ccId2Data: [],
        organizationData: [],
        showEdit: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        courseOptions: [],
        
      };
    },
    methods: {
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      f_reviewStatus(row, column, cellValue, index) {
        if (cellValue == '0' || cellValue == null) {
          return '未审核';
        }
           if (cellValue == '1' || cellValue == null) {
          return '不通过';
        }
        else if (cellValue == '2') {
          return '审核通过';
        }
        return '';
      },
      handleEdit(index, row) {
        this.showEdit[row.commodityId] = true;
        this.search();
      },
      dateFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      // handleSelectionChange(val) {
      //   this.multipleSelection = [];
      //   for (let index in val) {
      //     this.multipleSelection[index] = val[index].id;
      //   }
      // },
      noreviewStatus(row) {
        console.log("rowno:",row);
          let params = {
            "id":row.id,
            "reviewStatus":1
          };
          https.fetchPost('/webBlogComment/reviewBlogComment', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '不通过操作成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '不通过操作失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
      },
      okreviewStatus(row) {
          console.log("rowok:",row);
          let params = {
            "id":row.id,
            "reviewStatus":2
          };
          https.fetchPost('webBlogComment/reviewBlogComment', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '通过操作成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '通过操作失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
      },
      deleteBlogsComment(index, row) {
        this.$confirm('此操作将删除该评论, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            'id': row.id
            };
          https.fetchPost('/webBlogComment/deleteBlogComment', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      monthFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return monthFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      search(val) {
        if (this.searchData.blogId == null ) {
          return;
        } 
        let params = this.searchData;
        https.fetchPost('/webBlogComment/list', params, 'json').then((data) => {
          console.log("data;",data)
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.commodityData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
    },
    created: function() {
      this.searchData.orgCode = this.$store.state.orgCode;
      this.searchData.blogId = this.$route.params.id;
      console.log("searchData:",this.searchData);
      this.search();
    }
  };
</script>

<style scoped>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .line {
    text-align: center;
  }
  
  .edit-cell {
    width: 60%;
  }
  
  .cls-col {
    margin-right: 20px;
  }
  
  .target {
    margin-left: 10px;
    color: #409EFF;
  }
</style>
